<template>
  <div id="app" :class="{ show: showSidebar }">
    <HeaderLogo></HeaderLogo>
    <BurgerMenu></BurgerMenu>
    <Sidebar>
      <ul>
        <router-link @click.native="showMenuTimeOut" to="/" tag="li">
          <a>Home</a>
        </router-link>
        <!-- Aktionärsbrief -->
        <router-link
          @click.native="showMenuTimeOut"
          to="/aktionaersbrief"
          tag="li"
        >
          <a>Aktionärsbrief</a>
        </router-link>
        <!-- Unser Anspruch  -->
        <router-link @click.native="showMenuTimeOut" to="/anspruch" tag="li">
          <a>Unser Anspruch</a>
        </router-link>
        <!-- Verantwortung  -->
        <router-link
          @click.native="showMenuTimeOut"
          to="/verantwortung"
          tag="li"
        >
          <a>Wir handeln umweltbewusst und verantwortungsvoll</a>
        </router-link>
        <!-- Stabilitaet  -->
        <router-link @click.native="showMenuTimeOut" to="/stabilitaet" tag="li">
          <a>Wir geben Stabilität in unsicheren Zeiten</a>
        </router-link>
        <!-- Digital  -->
        <router-link @click.native="showMenuTimeOut" to="/digital" tag="li">
          <a>Wir sind digital und vernetzt</a>
        </router-link>
        <!-- Regional  -->
        <router-link @click.native="showMenuTimeOut" to="/regional" tag="li">
          <a>Wir agieren regional und kompetent</a>
        </router-link>
        <!-- E-Mobilität -->
        <router-link @click.native="showMenuTimeOut" to="/emobilitaet" tag="li">
          <a>Partner für Mobilitätswende</a>
        </router-link>
        <router-link
          @click.native="showMenuTimeOut"
          to="/netzeodr"
          tag="li"
          class="link-netz"
        >
          <a>Wir versorgen sicher und zukunftsgerichtet</a>
        </router-link>
        <!--  Engagement -->
        <router-link @click.native="showMenuTimeOut" to="/engagement" tag="li">
          <a>Wir sind menschlich und nah</a>
        </router-link>
        <!-- Mitarbeiter  -->
        <router-link @click.native="showMenuTimeOut" to="/mitarbeiter" tag="li">
          <a>Wir sind motiviert und verlässlich</a>
        </router-link>
        <router-link @click.native="showMenuTimeOut" to="/bilanz" tag="li">
          <a>Bilanz</a>
        </router-link>
        <router-link @click.native="showMenuTimeOut" to="/gewinn" tag="li">
          <a>Gewinn- und Verlustrechnung</a>
        </router-link>
      </ul>
    </Sidebar>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import HeaderLogo from "@/components/global/HeaderLogo";
import BurgerMenu from "@/components/global/BurgerMenu";
import Sidebar from "@/components/global/Sidebar";
import $ from "jquery";

export default {
  name: "Home",
  data() {
    return {
      showSidebar: false,
    };
  },
  components: {
    HeaderLogo,
    BurgerMenu,
    Sidebar,
  },
  methods: {
    showMenuTimeOut: () => {
      if (window.innerWidth < 768) {
        $("#app").toggleClass("show");
        $(window).scrollTop(0);
      }
    },
  },
};
</script>

<style lang="scss">
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 5s;
}

.fade-enter-active {
  transition-delay: 5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
